export default __webpack_public_path__ + "static/media/UmbrellaOrange.e0f71cb5.svg";